export type RequiredOptions = {
  _tableUrl: string;
};

export type OptionalOptions = {
  _columnsToFetch: number[];
  _initialVisibleColumns: number[];
  _initialRowsPerPage: number;
  _rowsPerPageOptions: number[];
  _initialDensity: DensityType;
  _defaultFilterVariant: FilterType;
  _overrideFilterVariants: null | {[key: number]: FilterType};
  _enableSearch: boolean;
  _enableFiltering: boolean;
  _enableSorting: boolean;
  _enablePagination: boolean;
  _enableDensityToggle: boolean;
  _enableFullScreenToggle: boolean;
  _enableColumnVisibilityToggle: boolean;
  _enableStickyHeader: boolean;
  _enableModalWindow: boolean;
  _maxTableHeight: null | string;
};

const Densities = ['compact', 'comfortable', 'spacious'] as const;
export type DensityType = typeof Densities[number];
export function isDensityType(value: string): value is DensityType {
  return (Densities as readonly string[]).includes(value);
}

const Filters = ['text', 'autocomplete', 'select', 'multi-select', 'range', 'range-slider', 'checkbox'] as const;
export type FilterType = typeof Filters[number];
export function isFilterType(value: string): value is FilterType {
  return (Filters as readonly string[]).includes(value);
}

export type Results = {
  data: any;
  fields: {
    name: any;
    filterVariant: FilterType;
  }[];
}
